<template>
    <div>
        <nav class="flex" aria-label="Breadcrumb">
            <ol class="flex items-center space-x-4">
                <li>
                    <div>
                        <a href="/admin/pages/desks" class="text-gray-400 hover:text-gray-500">
                            <!-- Heroicon name: solid/home -->
                            <svg class="flex-shrink-0 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                 fill="currentColor" aria-hidden="true">
                                <path
                                    d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"/>
                            </svg>
                            <span class="sr-only">Home</span>
                        </a>
                    </div>
                </li>

                <li>
                    <div class="flex items-center">
                        <svg class="flex-shrink-0 h-5 w-5 text-gray-300" xmlns="http://www.w3.org/2000/svg"
                             fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
                            <path d="M5.555 17.776l8-16 .894.448-8 16-.894-.448z"/>
                        </svg>
                        <a href="/admin/pages/zones"
                           class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700">Zonen</a>
                    </div>
                </li>

                <li v-if="!loading">
                    <div class="flex items-center">
                        <svg class="flex-shrink-0 h-5 w-5 text-gray-300" xmlns="http://www.w3.org/2000/svg"
                             fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
                            <path d="M5.555 17.776l8-16 .894.448-8 16-.894-.448z"/>
                        </svg>
                        <a href="#" class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                           aria-current="page">
                            {{ zone.name }}
                        </a>
                    </div>
                </li>
            </ol>
        </nav>

        <headline class="mt-4">
            Zone <span class="font-bold">{{ zone.name }}</span>

            <template v-slot:more>
                <zone-edit :id="id" @updated="load"></zone-edit>
            </template>
        </headline>

        <loading v-show="loading"></loading>

        <div v-if="!loading">

          <tailwind-table class="mb-4" :header="['Schreibtische']" v-show="zone?.desks?.length > 0">
            <tr v-for="(desk, i) in zone.desks" :class="{'bg-gray-50': i % 2}">
              <td class="px-6 py-2">
                  {{ desk.name }}
              </td>
            </tr>
          </tailwind-table>

            <tailwind-table class="mb-4" :header="['Kategorie', 'Bookable']" v-show="zone?.bookables?.length > 0">
                <tr v-for="(bookable, i) in zone.bookables" :class="{'bg-gray-50': i % 2}">
                    <td class="px-6 py-2">
                            {{ bookable.bookable_category?.name }}
                    </td>
                    <td class="px-6 py-2">
                            {{ bookable.name }}
                    </td>
                </tr>
            </tailwind-table>

            <tailwind-table class="mb-4" :header="['Konferenzraum']" v-show="zone?.conference_rooms?.length > 0">
                <tr v-for="(conf, i) in zone.conference_rooms" :class="{'bg-gray-50': i % 2}">
                    <td class="px-6 py-2">
                            {{ conf.name }}
                    </td>
                </tr>
            </tailwind-table>
        </div>
    </div>
</template>

<script>
import Headline from "../components/UI/Headline";
import Loading from "../components/UI/Loading";
import ZoneEdit from "../components/ZoneEdit";
import TailwindTable from "../components/UI/TailwindTable";
import CardFullInvisible from "../components/UI/CardFullInvisible";
import RoomCreate from "../components/RoomCreate";
import Card from "../components/UI/Card";
import ButtonSecondary from "../components/UI/ButtonSecondary";
import SelectMenu from "../components/UI/SelectMenu";
import ButtonPrimary from "../components/UI/ButtonPrimary";

export default {
    name: "ZoneShow",

    components: {
        ButtonPrimary,
        SelectMenu,
        ButtonSecondary,
        Card,
        RoomCreate,
        CardFullInvisible,
        TailwindTable,
        ZoneEdit,
        Loading,
        Headline,
    },

    props: ['id'],

    data: () => ({
        loading: false,
        showEditFloor: false,
        zone: {},
        floors: [],
    }),

    mounted() {
        this.load();
    },

    methods: {
        load() {
            this.loading = true;
            this.$http.get(`/admin/zones/${this.id}`).then((response) => {
                this.zone = response.data.data;
                this.floors = response.data.floors;
                this.loading = false;
            }).catch(error => {
                this.$emit('error', error);
                this.loading = false;
            });
        },
        update() {
            this.loading = true;
            this.$http.post(`/admin/zones/${this.id}`, {
                _method: 'put',
                floor_id: this.zone.floor_id,
            }).then(() => {
                this.showEditFloor = false;
                this.load();
            }).catch(error => {
                this.$root.$emit('error', error);
                this.loading = false;
            });
        },
    },
}
</script>

<style scoped>

</style>
